import React from 'react';
import { Tag, Typography } from 'antd';
import { RELEASES } from '../release-notes';

const { Title, Paragraph, Text } = Typography;

export default function ReleaseNotesPage() {
  return (
    <div className="workflow-shell__content" style={{ maxWidth: 720 }}>
      <Title
        level={1}
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-title)',
          letterSpacing: 'var(--tracking-title)',
          marginBottom: 4,
        }}
      >
        Release notes
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 'var(--space-8)' }}>
        What shipped in Artificiallly, newest first.
      </Paragraph>

      <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-8)' }}>
        {RELEASES.map((release) => (
          <li key={release.version}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 10,
                marginBottom: 12,
              }}
            >
              <Tag color="blue">{release.version}</Tag>
              <Text type="secondary">{release.date}</Text>
            </div>
            {release.groups.map((group) => (
              <div key={group.heading} style={{ marginBottom: 16 }}>
                <Title level={4} style={{ marginBottom: 8, fontFamily: 'var(--font-display)' }}>
                  {group.heading}
                </Title>
                <ul style={{ margin: 0, paddingInlineStart: 20 }}>
                  {group.items.map((item) => (
                    <li key={item} style={{ marginBottom: 6, color: 'var(--color-text)' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </li>
        ))}
      </ol>
    </div>
  );
}
